import { render, staticRenderFns } from "./PropertyTenureSelect.vue?vue&type=template&id=6ac93a70&"
import script from "./PropertyTenureSelect.vue?vue&type=script&lang=js&"
export * from "./PropertyTenureSelect.vue?vue&type=script&lang=js&"
import style0 from "./PropertyTenureSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports